// Deprecated

'use strict';

module.exports = function (obj) { return typeof obj === 'function'; };



/*****************
 ** WEBPACK FOOTER
 ** /Users/dan/p/react-devtools/~/es5-ext/object/is-callable.js
 ** module id = 199
 ** module chunks = 0
 **/